import { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'

import { useResponsive } from 'hooks'

import Button from 'components/Button'

import './style.scss'

const Ellipsis = ({
  children,
  maxHeight = 160,
}: {
  children: any
  maxHeight?: number
}) => {
  const { t } = useTranslation()
  const ref = useRef(null)
  const [hidden, setHidden] = useState(false)
  const { isDesktop } = useResponsive()

  // By waiting the component render to check his height,
  // there's a really fast glitch in between of rendered -> hidden
  const [avoidGlitch, setAvoidGlitch] = useState(false)

  useEffect(() => {
    if (ref?.current?.clientHeight > maxHeight && !isDesktop) {
      setHidden(true)
    }

    setAvoidGlitch(true)
  }, [])

  return (
    <div
      ref={ref}
      className={cx('Ellipsis', hidden && 'Ellipsis--hidden')}
      style={{
        maxHeight: hidden ? maxHeight : 'max-content',
        opacity: avoidGlitch ? 1 : 0,
      }}
    >
      <div className="Ellipsis__content">{children}</div>

      {hidden && (
        <Button buttonStyle="white" onClick={() => setHidden(false)}>
          {t('common.see_more')}
        </Button>
      )}
    </div>
  )
}

export default Ellipsis
